import { ReactNode } from "react"

import { css, cx } from "@emotion/css"

import { useI18n } from "providers/I18n"

const styles = {
  table: css`
    .wrap-row {
      position: relative;
      padding-bottom: 0.5rem;
    }

    .row-action {
      position: absolute;
      right: 0;
      top: 0;
    }

    .row {
      display: grid;
      position: relative;
      grid-auto-flow: column;
      grid-template-columns: 200px 250px 220px repeat(auto-fill, 60px);
    }

    .thr {
      height: 42px;
    }

    .tbr {
      height: 52px;
      border: 1px solid var(--primary-main);
      border-radius: 3px;
    }

    .cell {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      > div {
        position: relative;
        width: 100%;
      }

      .MuiFormHelperText-root {
        line-height: initial;
        margin-top: 0;
        position: absolute;
        top: 30px;
      }
    }

    .thc {
      font-size: 0.8125rem;
      padding: 6px;
      font-weight: 400;
      line-height: 1.43;
      color: #9b9b9b;
      align-items: flex-end;
    }

    .tbc {
      font-size: 0.875rem;
      padding: 4px;
      font-weight: 500;
      line-height: 1.5;
      color: #000;
    }
  `,
}

type SayItsATableProps = {
  children: ReactNode
  className?: string
}

export function SayItsATable(props: SayItsATableProps) {
  const { children } = props

  return (
    <div role="table" className={cx(styles.table, props.className)}>
      {children}
    </div>
  )
}

type SayItsATableHeaderProps = {
  columns: readonly { id: string; header: string; width?: number }[]
}
export function SayItsATableHeader(props: SayItsATableHeaderProps) {
  const { t } = useI18n()
  return (
    <div role="rowgroup">
      <div role="row" className="row thr">
        {props.columns.map((col) => {
          return (
            <div
              key={col.id + col.header}
              className="cell thc"
              role="columnheader"
              title={t(col.header)}
              style={{ width: col.width }}
            >
              {t(col.header)}
            </div>
          )
        })}
      </div>
    </div>
  )
}

type SayItsATableBodyProps = {
  children: ReactNode
}
export function SayItsATableBody(props: SayItsATableBodyProps) {
  return <div role="rowgroup">{props.children}</div>
}

type SayItsATableBodyRowProps = {
  children: ReactNode
  action?: ReactNode
}
export function SayItsATableBodyRow(props: SayItsATableBodyRowProps) {
  return (
    <div role="row" className="wrap-row">
      <div className="row tbr" data-testid="media-plan-table-row">
        {props.children}
      </div>
      {props.action ? <div className="row-action">{props.action}</div> : null}
    </div>
  )
}

type SayItsATableBodyCellProps = {
  children: ReactNode
}

export function SayItsATableBodyCell(props: SayItsATableBodyCellProps) {
  return (
    <div role="cell" className="cell tbc" data-testid="create-plan-table-cell">
      {props.children}
    </div>
  )
}
